import Vue from "vue";
import vueResource from "vue-resource";

Vue.use(vueResource);
Vue.http.options.emulateJSON = true;
Vue.http.headers.common["version"] = "yunst";

function _POST ({ commit }, url = "", params = {}) {
  return Vue.http
    .post(url, params)
    .then(res => {
      const json = res.json();
      if (res.status === 200 || (res.status === 302 && json.status !== 403)) {
        // HTML Status
        return json; //  返回数据
      } else {
        return Promise.reject(res);
      }
    })
    .catch(res => {
      if (res.status === 302 || res.status === 0) {
        commit("HAS_LOGGED_OUT");
      }
      return Promise.reject(res);
    });
}

function ProtocalError (code, msg, data) {
  this.code = code || "0";
  this.msg = msg || "系统错误";
  this.originData = data;
  this.stack = new Error().stack;
}

ProtocalError.prototype = Object.create(Error.prototype);
ProtocalError.prototype.constructor = ProtocalError;

const protocalPrefix = "";
// const protocalMaxLimit = 50;

function POST ({ dispatch, commit }, _url = "", _params = {}) {
  const url = protocalPrefix + _url;
  const params = emptyParamsFilter(_params);
  return _POST(
    {
      dispatch,
      commit
    },
    url,
    params
  )
    .then(({ data, code, msg }) => {
      // Protocal Status
      if (code === 1001) {
        return data;
      } else if (code === 28100 || code === 54000) {
        // 未登陆
        commit("HAS_LOGGED_OUT");
      } else {
        return Promise.reject(new ProtocalError(code, msg, data));
      }
    })
    .catch(res => {
      return res.data ? Promise.reject(res.data) : Promise.reject(res);
    });
}

function emptyParamsFilter (source) {
  if (typeof source === "object") {
    let o = {};
    for (let i in source) {
      if (
        typeof source[i] !== "undefined" &&
        source[i] !== null &&
        source[i] !== ""
      ) {
        o[i] = source[i];
      }
    }
    return o;
  } else {
    return source;
  }
}

export default {
  LOGIN_WITH_VERIFY (
    { dispatch, commit },
    { mobile, verify_code, type, wallet_level } = {}
  ) {
    const url = "/wallet_web/v1/login_with_verify_code";
    const params = {
      mobile,
      verify_code,
      type,
      wallet_level
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(data => {
        commit("IS_LOGIN");
        commit("SET_USER_INFO", data);
        dispatch("GET_WALLET_INFO");
        return data;
      })
      .catch(res => {
        if (res.code === 28101 || res.code === 28102) {
          commit("IS_LOGIN");
        }
        return Promise.reject(res);
      });
  },

  SEND_VERIFY_CODE (
    { dispatch, commit },
    { mobile, type, verify_token, redirect_url } = {}
  ) {
    const url = "/wallet_web/v1/send_verify_code";
    const params = {
      mobile,
      type,
      verify_token,
      redirect_url
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  SEND_BIND_VERIFY_CODE (
    { dispatch, commit },
    { id_no, verify_token, redirect_url } = {}
  ) {
    const url = "/wallet_web/v1/senior/user/send_bind_verify_code";
    const params = {
      id_no,
      verify_token,
      redirect_url
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  CHECK_LOGIN ({ dispatch, commit }) {
    return dispatch("GET_WALLET_INFO")
      .then(data => {
        if (data) {
          commit("IS_LOGIN");
        } else {
          commit("NOT_LOGIN");
        }
      })
      .catch(() => {
        commit("HAS_LOGGED_OUT");
      });
  },

  /**********
   *  注销  *
   **********/
  LOGOUT ({ dispatch, commit }) {
    const url = "/v1/person/user/logout";

    return POST(
      {
        dispatch,
        commit
      },
      url,
      {}
    )
      .then(() => {
        commit("HAS_LOGGED_OUT");
      })
      .catch(() => {
        commit("HAS_LOGGED_OUT");
      });
  },

  /*****************
   *  获取钱包信息  *
   *****************/
  GET_WALLET_INFO ({ dispatch, commit }) {
    const url = "/wallet_web/v1/wallet_info";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(data => {
        commit("SET_WALLET_INFO", data);
        try {
          const evtObj = {
            event_id: "wallet_info",
            param: data
          };
          window.rfReport.addEvent(evtObj);
        } catch (error) {
          console.log("rfReport上报用户行为报错====>", error);
        }
        return Promise.resolve(data);
      })
      .catch(res => {
        return Promise.reject(res);
      });
  },

  /*****************
   *  获取用户信息  *
   *****************/
  GET_USER_INFO ({ dispatch, commit }) {
    const url = "/wallet_web/v1/user";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(data => {
        commit("SET_USER_INFO", data);
        try {
          window.rfReport.addData((extData) => {
            extData.user_id = data.user_id
          })
        } catch (error) {
          console.log('rfReport上报用户id报错====>', error)
        }

        return Promise.resolve(data);
      })
      .catch(res => {
        return Promise.reject(res);
      });
  },

  /*********************************************************/

  /*****************
   *  外部登陆认证  *
   *****************/
  SSO_LOGIN (
    { dispatch, commit },
    {
      grant_token,
      callback_url,
      business_remark,
      timestamp,
      sign,
      wallet_level
    } = {}
  ) {
    const url = "/wallet_web/v1/sso";
    const params = {
      grant_token,
      callback_url,
      business_remark,
      timestamp,
      sign,
      wallet_level
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(data => {
        commit("IS_LOGIN");
        commit("SET_USER_INFO", data);
        dispatch("GET_WALLET_INFO");
        return data;
      })
      .catch(res => {
        if (res.code === 28101 || res.code === 28102) {
          commit("IS_LOGIN");
        }
        return Promise.reject(res);
      });
  },

  /******************
   *  接受用户协议  *
   ******************/
  ACCEPT_PROTOCOL ({ dispatch, commit }) {
    const url = "/wallet_web/v1/accept_protocol";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /**************
   *  创建钱包  *
   **************/
  CREATE_WALLET ({ dispatch, commit }) {
    const url = "/wallet_web/v1/wallet/create";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(data => {
        commit("SET_WALLET_INFO", data);

        return Promise.resolve(data);
      })
      .catch(res => {
        return Promise.reject(res);
      });
  },

  /*******************
   *  验证身份有效性  *
   *******************/
  IDENTITY_VERIFY (
    { dispatch, commit },
    {
      id_no,
      name
      // verify_code,
      // type
    } = {}
  ) {
    const url = "/wallet_web/v1/verify/identity";
    const params = {
      id_no,
      id_type: 1,
      name
      // verify_code,
      // type
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*********************
   *  获取银行名称列表  *
   *********************/
  GET_BANK_CLASS_LIST ({ dispatch, commit }) {
    const url = "/wallet_web/v1/wallet/bank/class_list";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取银行地区列表  *
   *********************/
  GET_BANK_AREA_LIST ({ dispatch, commit }, class_code) {
    const url = "/wallet_web/v1/wallet/bank/area_list";
    const params = {
      class_code
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取支行名称列表  *
   *********************/
  GET_BANK_LIST ({ dispatch, commit }, { class_code, area_code }) {
    const url = "/wallet_web/v1/wallet/bank/list";
    const params = {
      class_code,
      area_code
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*******************
   *  获取银行卡列表  *
   *******************/
  GET_BANK_CARD_LIST ({ dispatch, commit }) {
    const url = "/wallet_web/v1/bank_card_list";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************
   *  绑定银行卡  *
   ***************/
  BIND_CARD ({ dispatch, commit }, { bank_account, bank_code }) {
    const url = "/wallet_web/v1/bind/bank_card";
    const params = {
      bank_account,
      bank_code
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*****************
   *  查询交易记录  *
   *****************/
  GET_TRANSFER_HISTORY_LIST (
    { dispatch, commit },
    { limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/wallet_web/v1/trans_history_list";
    const params = {
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  重新发起转账  *
   *****************/
  REDO_PAY ({ dispatch, commit }, apply_id) {
    const url = "/wallet_web/v1/redo_pay";
    const params = {
      apply_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-通道注册短信   *
   ***************************/
  SEND_VERIFY_CODE_SENIOR ({ dispatch, commit }, { id_no, real_name } = params) {
    const url = "/wallet_web/v1/senior/user/send_register_verify_code";
    const params = {
      id_no,
      real_name
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包个人身份验证   *
   ***************************/
  REGIST_VERIFY ({ dispatch, commit }, params) {
    const url = "/wallet_web/v1/senior/wallet/regist_verify";

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-通道升级短信   *
   ***************************/
  SEND_UPDATE_VERIFY_CODE ({ dispatch, commit }) {
    const url = "/wallet_web/v1/senior/user/send_update_verify_code";
    return POST(
      {
        dispatch,
        commit
      },
      url
    );
  },

  /***************************
   *  高级钱包-升级身份验证   *
   ***************************/
  UPDATE_VERIFY ({ dispatch, commit }, { jump_url, verify_code } = {}) {
    const url = "/wallet_web/v1/senior/wallet/update_verify";
    const params = {
      jump_url,
      verify_code
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包个人会员电子会员协议   *
   ***************************/
  SIGN_MEMBER_CONTRACT ({ dispatch, commit }) {
    const url = "/wallet_web/v1/senior/wallet/sign_member_contract";
    const params = {
      jump_url: "/%23/sepp"
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包个人设置交易密码   *
   ***************************/
  PERSON_SET_PAY_PASSWORD ({ dispatch, commit }) {
    const url = "/wallet_web/v1/senior/wallet/person_set_pay_password";
    const params = {
      jump_url: "/%23/bindCardSeniorWallet"
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-预绑定储蓄卡   *
   ***************************/
  BIND_DEBIT_CARD ({ dispatch, commit }, params) {
    const url = "/wallet_web/v1/senior/card/bind_debit_card";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-绑定信用卡   *
   ***************************/
  BIND_CREDIT_CARD ({ dispatch, commit }, params) {
    const url = "/wallet_web/v1/senior/card/bind_credit_card";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-确定绑卡   *
   ***************************/
  CONFIRM_BIND_CARD ({ dispatch, commit }, params) {
    const url = "/wallet_web/v1/senior/card/confirm_bind_card";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-升级钱包-完善银行卡（绑卡）   *
   ***************************/
  // UPGRADE_DEBIT_CARD ({ dispatch, commit }, params) {
  //   const url = "/wallet_web/v1/senior/card/upgrade_debit_card";
  //   return POST(
  //     {
  //       dispatch,
  //       commit
  //     },
  //     url,
  //     params
  //   );
  // },
  // 优化需求，改用2接口
  // 比之前多了一个参数bank_account银行卡号，如果有传就无视card_id，如果没传就认card_id
  UPGRADE_DEBIT_CARD ({ dispatch, commit }, params) {
    const url = "/wallet_web/v1/senior/card/upgrade_debit_card2";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-解绑银行卡   *
   ***************************/
  UNBIND_BANK_CARD ({ dispatch, commit }, card_id) {
    const url = "/wallet_web/v1/senior/card/unbind_bank_card";
    const params = {
      card_id
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-设置默认银行卡   *
   ***************************/
  SET_DEFAULT_BANK_CARD ({ dispatch, commit }, card_id) {
    const url = "/wallet_web/v1/wallet/card/set_default";
    const params = {
      card_id
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-充值   *
   ***************************/
  RECHARGE ({ dispatch, commit }, params) {
    const url = "/wallet_web/v1/senior/pay/recharge";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-提现   *
   ***************************/
  WITHDRAW ({ dispatch, commit }, params) {
    const url = "/wallet_web/v1/senior/pay/withdraw";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *       高级钱包-短信确认   *
   ***************************/
  SMS_CONFIRM ({ dispatch, commit }, params) {
    const url = "/wallet_web/v1/senior/pay/sms_confirm";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *      高级钱包-重发短信    *
   ***************************/
  SMS_RETRY ({ dispatch, commit }, params) {
    const url = "/wallet_web/v1/senior/pay/sms_retry";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  设置安全页面的数据  *
   ***************************/
  SET_SAFETY_VERIFICATION ({ dispatch, commit }, params) {
    commit("SET_SAFETY_VERIFICATION", params);
  },

  /***************************
   *  高级钱包修改交易密码   *
   ***************************/
  UPDATE_PAY_PWD ({ dispatch, commit }) {
    const url = "/wallet_web/v1/senior/update_pay_pwd";
    const params = {
      jump_url: "/%23/updatePayPwd"
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包修改安全手机   *
   ***************************/
  RESET_SECURITY_TEL ({ dispatch, commit }) {
    const url = "/wallet_web/v1/senior/reset_security_tel";
    const params = {
      jump_url: "/%23/resetSecurityTel"
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  查询交易记录  *
   *****************/
  ORDER_LIST (
    { dispatch, commit },
    { limit = 10, offset = 0, stat = true, type = "1,4,5,6,7" } = {}
  ) {
    const url = "/wallet_web/v1/order_list";
    const params = {
      limit,
      offset,
      stat,
      type
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包-修改银行卡非敏感信息   *
   ***************************/
  MODIFY_CARD_EXT_INFO ({ dispatch, commit }, { bank_code, card_id } = {}) {
    const url = "/wallet_web/v1/senior/card/modify_card_ext_info";
    const params = {
      bank_code,
      card_id
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  绑定钱包-高级 *
   ***************************/
  BIND_WALLET ({ dispatch, commit }, { verify_code } = {}) {
    const url = "/wallet_web/v1/senior/user/bind_with_verify_code";
    const params = {
      verify_code
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  绑定钱包-初级  *
   ***************************/
  BIND_WITH_VERIFY_CODE ({ dispatch, commit }, { verify_code } = {}) {
    const url = "/wallet_web/v1/junior/user/bind_with_verify_code";
    const params = {
      verify_code
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  高级钱包重置交易密码   *
   ***************************/
  RESET_PAY_PWD ({ dispatch, commit }) {
    const url = "/wallet_web/v1/senior/reset_pay_pwd";
    const params = {
      jump_url: "/%23/resetPayPwd"
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
 *  高级钱包委托代扣协议协议   *
 ***************************/
  DEDUCT_CONTRACT ({ dispatch, commit }) {
    const url = "/wallet_web/v1/senior/wallet/deduct_contract";
    const params = {
      jump_url: "/%23/deductContractSuccess"
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  }
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js